import styled from 'styled-components';

import Controls from './Controls';
import Image from './Image';

const ImageEditor = styled.div`
  position: relative;
`;

ImageEditor.Controls = Controls;
ImageEditor.Image = Image;

export default ImageEditor;
